import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=d5c2bfa2&scoped=true"
import script from "./notification.vue?vue&type=script&lang=ts"
export * from "./notification.vue?vue&type=script&lang=ts"
import style0 from "./notification.vue?vue&type=style&index=0&id=d5c2bfa2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c2bfa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5c2bfa2')) {
      api.createRecord('d5c2bfa2', component.options)
    } else {
      api.reload('d5c2bfa2', component.options)
    }
    module.hot.accept("./notification.vue?vue&type=template&id=d5c2bfa2&scoped=true", function () {
      api.rerender('d5c2bfa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notification/notification.vue"
export default component.exports